import { Component, OnInit, Input } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { BehaviorSubject } from 'rxjs';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ab-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() showLoader;
  isLoading: BehaviorSubject<boolean>;

  preventAutoBlocking = false;

  constructor(private loaderService: LoaderService) {
    this.isLoading = this.loaderService?.isLoading;
  }

  ngOnInit() {
    if (this.showLoader !== undefined) {
      this.preventAutoBlocking = true;
    } else {
      this.showLoader = false;
    }
  }
}
